import React from 'react';
import { TitleFull as Title } from '@warehouse/title/core';
import ProductMetadataTabLocalizedInfoTab from './localizedInfo';
import SideMenuTabs from '../../../../components/library/SideMenuTabs';
import ProductMetadataTabAncillaryTab from './ancillary';
import ProductMetadataTabTerritoriesTab from './regionalizedInfos';
import ProductMetadataTabCastAndCrewTab from './castAndCrew';
import { CastAndCrewContextProvider } from './castAndCrew/providers/castAndCrewProvider';

interface ProductMetadataTabProps {
	title: Title | undefined;
	wrapperRef: React.RefObject<HTMLDivElement>;
}

export function ProductMetadataTab({ title, wrapperRef }: ProductMetadataTabProps) {
	const tabs = [
		{
			label: 'Localized Info',
			urlState: 'product-metadata/localized-info/',
			defaultUrlState: 'product-metadata/localized-info/default',
			component: <ProductMetadataTabLocalizedInfoTab />,
		},
		{
			label: 'Cast & Crew',
			urlState: 'product-metadata/cast-crew/',
			defaultUrlState: 'product-metadata/cast-crew/default',
			component: (
				<CastAndCrewContextProvider title={title}>
					<ProductMetadataTabCastAndCrewTab wrapperRef={wrapperRef} />
				</CastAndCrewContextProvider>
			),
		},
		{
			label: 'Ratings & Releases',
			urlState: 'product-metadata/ratings-releases/',
			defaultUrlState: 'product-metadata/ratings-releases/default',
			component: <ProductMetadataTabTerritoriesTab />,
		},
		{
			label: 'Ancillary',
			urlState: 'product-metadata/ancillary',
			component: <ProductMetadataTabAncillaryTab />,
		},
	];

	return <SideMenuTabs leftColumnWidth={200} tabs={tabs} />;
}
